<template>
	<div>
		<page-title heading="Detail Stok"
			:breadcrumb="[
				{
					label: 'Manajemen Stok',
					link: '/manajemen-obat-bhp'
				},
				{
					label: 'Laporan Stok',
					link: '/klinik/stok/report'
				},
				{
					label: 'Detail Stok',
					active: true
				},
			]"
			class="layout-gantung ninja-shadow" />

		<div class="container-fluid">
			<div class="ml-4 mb-3">
				<b-button variant="outline-dark"
					class="align-self-end font-weight-bold mr-2"
					:to="{
						name: 'klinik-stok-report-detail',
						query: {
							from: this.from[0],
							to: this.from[1]
						}
					}"
					style="border-radius:0.65rem">
					Log Stok
				</b-button>
				<b-button variant="outline-primary"
					class="align-self-end font-weight-bold"
					:to="{
						name: 'klinik-stok-report-detail-sell',
						query: {
							from: this.from[0],
							to: this.from[1]
						}
					}"
					style="border-radius:0.65rem">
					Log Stok Penjualan
				</b-button>
			</div>
			<div class="card card-box ninja-shadow">
				<div class="card-body">
					<b-row class="head-filter">
						<b-col cols="6">
							<b-row class="align-items-center">
								<b-col cols="4">
									<label
										class="lb-header-filter">Kategori</label>
								</b-col>
								<b-col cols="7">
									{{ dataDetail.category || '-' }}
								</b-col>
							</b-row>
							<b-row class="align-items-center">
								<b-col cols="4">
									<label class="lb-header-filter">Nama
										Obat/BHP</label>
								</b-col>
								<b-col cols="7">
									{{ dataDetail.name || '-' }}
								</b-col>
							</b-row>
							<b-row class="align-items-center">
								<b-col cols="4">
									<label
										class="lb-header-filter">Satuan</label>
								</b-col>
								<b-col cols="7">
									{{ dataDetail.satuan || '-' }}
								</b-col>
							</b-row>
						</b-col>
						<b-button variant="danger"
							class="align-self-start mr-3"
							@click="downloadReport">
							<font-awesome-icon icon="download" />
							Download Data
						</b-button>
					</b-row>
					<div class="stright-line"></div>
					<b-col md="12">
						<DataTableWrapper :perPage="perPage"
							:customEntryOptions="{ f: [5] }"
							:fromPage="fromPage"
							:toPage="toPage"
							:totalEntries="totalEntries"
							:currentPage="currentPage"
							:callbackFunc="fetchDetail"
							@valueChanged="handleValueChanged">

							<b-table :items="laporanStockList"
								:fields="fieldList"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								thead-tr-class="izd-datatable"
								:no-local-sorting="true">

								<!-- slot head -->
								<template v-slot:head(date)="data">
									{{ data.label }}
									<div class="mt-2">
										<date-picker v-model="from"
											type="date"
											range
											format="DD-MM-YYYY"
											value-type="YYYY-MM-DD"
											placeholder="DD-MM-YYYY"
											:style="'width: 100%'"
											@input="searchValueChanged($event, 'from')"
											id="dt-picker-detail-stock">
										</date-picker>
									</div>
								</template>

								<template v-slot:head(invoice_number)="data">
									{{ data.label }}
									<b-input size="sm"
										class="mt-2 w-95"
										v-if="data.field.searchable"
										@input="searchValueChanged($event, data.field.key)" />
								</template>

								<template v-slot:cell(invoice_number)="data">
									<router-link :to="{
										name: data.item.is_penjualan ? 'klinik-penjualan-struk' : 'klinik-pembayaran-struk',
										params: {
											pembayaran_id: data.item.payment_id,
											id: data.item.payment_id,
										}
									}"
										style="cursor: pointer"
										target="_blank">{{
												data.item.invoice_number
										}}
									</router-link>
								</template>

							</b-table>
						</DataTableWrapper>
					</b-col>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import debounce from "lodash/debounce";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
moment.locale("id");

import {
	faCopy,
	faDownload,
	faSearch
} from "@fortawesome/free-solid-svg-icons";

library.add(faCopy, faDownload, faSearch);

export default {
	components: {
		DataTableWrapper: () => import("../../../components/DataTableWrapper"),
		DatePicker
	},
	data() {
		return {
			firstLoadDetail: true,
			dataDetail: {},
			id: null,

			from: [moment().startOf('month').format('YYYY-MM-DD'), moment().format("YYYY-MM-DD")],
			to: null,

			perPage: 10,
			currentPage: 1,
			rows: 0,
			fromPage: 0,
			toPage: 0,
			totalEntries: 0,
			sortBy: "",
			sortDesc: false,
			searchValue: [],
			laporanStockList: [],
			fieldList: [
				{
					key: "date",
					label: "hari & tanggal",
					searchable: true,
					sortable: true
				},
				{
					key: "invoice_number",
					label: "no invoice",
					thStyle: "width:20%;",
					searchable: true,
					sortable: false
				},
				{
					key: "used_stock",
					label: "penggunaan obat/BHP",
					thStyle: "width:20%; text-align: center;",
					tdClass: "text-center",
					searchable: false,
					sortable: true
				},
				{
					key: "remaining_stock",
					label: "sisa stok",
					thStyle: "width:20%; text-align: center;",
					tdClass: "text-center",
					tdClass: "text-center",
					searchable: false,
					sortable: true
				}
			],
		};
	},
	computed: {
		...mapGetters(["getKlinikId", "klinikUser"]),
		klinik() {
			let klinikCurr = this.$store.state.klinikUser.filter((item) => {
				return (item.pivot.klinik_id === this.$store.state.klinikId)
			});

			return klinikCurr[0];
		},
	},
	mounted() {
	},
	watch: {
		currentPage(val) {
			this.fetchDetail();
		},
		perPage() {
			this.fetchDetail();
		},
		sortBy() {
			this.fetchDetail();
		},
		sortDesc() {
			this.fetchDetail();
		},
		searchValue: {
			handler: function (val) {
				if (!this.firstLoadDetail) this.fetchDetail();
			},
			deep: true
		}
	},
	methods: {
		getTodayDate() {
			return [moment(this.fromParam).format('YYYY-MM-DD'), moment(this.toParam).format("YYYY-MM-DD")];
		},
		getSampleData() {
			return new Promise((resolve, reject) => {
				setTimeout(() => {
					resolve({
						status: true,
						data: {
							total: 10,
							from: 1,
							to: 10,
							data: [
								{
									"id": 1,
									"date": "Senin, 12 September 2022",
									"log_stock": -5,
									"total_stock": 85,
									"last_modified_date": "Jun 10, 2021 @ 10.28",
									"last_modified_by": "Valinda"
								},
								{
									"id": 2,
									"date": "Senin, 12 September 2022",
									"log_stock": -5,
									"total_stock": 85,
									"last_modified_date": "Jun 10, 2021 @ 10.28",
									"last_modified_by": "Valinda"
								},
								{
									"id": 3,
									"date": "Senin, 12 September 2022",
									"log_stock": -5,
									"total_stock": 85,
									"last_modified_date": "Jun 10, 2021 @ 10.28",
									"last_modified_by": "Valinda"
								},
								{
									"id": 4,
									"date": "Senin, 12 September 2022",
									"log_stock": -5,
									"total_stock": 85,
									"last_modified_date": "Jun 10, 2021 @ 10.28",
									"last_modified_by": "Valinda"
								},
								{
									"id": 5,
									"date": "Senin, 12 September 2022",
									"log_stock": -5,
									"total_stock": 85,
									"last_modified_date": "Jun 10, 2021 @ 10.28",
									"last_modified_by": "Valinda"
								},
								{
									"id": 1,
									"date": "Senin, 12 September 2022",
									"log_stock": -5,
									"total_stock": 85,
									"last_modified_date": "Jun 10, 2021 @ 10.28",
									"last_modified_by": "Valinda"
								},
								{
									"id": 2,
									"date": "Senin, 12 September 2022",
									"log_stock": -5,
									"total_stock": 85,
									"last_modified_date": "Jun 10, 2021 @ 10.28",
									"last_modified_by": "Valinda"
								},
								{
									"id": 3,
									"date": "Senin, 12 September 2022",
									"log_stock": -5,
									"total_stock": 85,
									"last_modified_date": "Jun 10, 2021 @ 10.28",
									"last_modified_by": "Valinda"
								},
								{
									"id": 4,
									"date": "Senin, 12 September 2022",
									"log_stock": -5,
									"total_stock": 85,
									"last_modified_date": "Jun 10, 2021 @ 10.28",
									"last_modified_by": "Valinda"
								},
								{
									"id": 5,
									"date": "Senin, 12 September 2022",
									"log_stock": -5,
									"total_stock": 85,
									"last_modified_date": "Jun 10, 2021 @ 10.28",
									"last_modified_by": "Valinda"
								},
							]
						}
					});
				}, 500);
			});
		},
		async fetchDetail() {
			if (this.firstLoadDetail) {
				this.fromParam = this.$router.currentRoute.query.from;
				this.toParam = this.$router.currentRoute.query.to;
				this.from = this.getTodayDate();

				this.searchValue = [
					{
						key: "from",
						value: this.from
					}
				];
			}
			this.firstLoadDetail = false;

			let id = this.$router.currentRoute.params.id;
			this.id = id;
			let res = await this.$axios.get(`klinik/stock/report/${this.id}/sell_stock?klinik_id=${this.getKlinikId}
			&limit=${this.perPage}&page=${this.currentPage}${this.determineParameter()}`);

			if (!res) {
				return;
			}

			const { status, data } = res;
			if (status) {
				this.dataDetail = data.layanan;

				const {
					data: laporanStockList,
					total: totalEntries,
					to: toPage,
					from: fromPage
				} = data.data; //data.data

				this.laporanStockList = laporanStockList;
				this.rows = totalEntries || 0;
				this.toPage = toPage || 0;
				this.fromPage = fromPage || 0;
				this.totalEntries = totalEntries;

				return this;
			}
		},
		// SETTING TABLE
		handleValueChanged({ perPage, currentPage }) {
			perPage && (perPage |> (_ => (this.perPage = _)));
			currentPage && (currentPage |> (_ => (this.currentPage = _)));
		},
		searchValueChanged: debounce(function (val, key) {
			if (key == "from" && val[0] == null && val[1] == null) {
				val = this.from = this.getTodayDate()
			}

			const { searchValue } = this;

			const z = searchValue.filter(item => item.key !== key);

			this.searchValue = [
				...z,
				{
					key,
					value: val
				}
			];

		}, 500),
		determineParameter() {
			const { searchValue, sortBy, sortDesc } = this;
			let v = "";

			searchValue.map(item => {
				const x = item.key;
				if (item.key == "from") {
					v += `&from=${item.value[0] || ""}`;
					v += `&to=${item.value[1] || ""}`;
				} else {
					v += `&${x}=${item.value || ""}`;
				}
			});

			if (sortBy) {
				v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
			}

			return v;
		},
		async downloadReport() {
			let res = await this.$axios.get(`klinik/stock/report/${this.id}/sell_stock/export?klinik_id=${this.getKlinikId}
			${this.determineParameter()}`);

			const { status, data } = res.data;

			if (status) {
				let link = document.createElement("a");
				link.href = data.link;
				link.setAttribute("download", data.name);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} else {
				this.$swal({
					text: "Something went wrong",
					type: "error"
				});
			}
		},
	}
};
</script>
  
<style scoped lang="css">
.bg-kuning {
	background: #f7fc6b;
}

.bg-kuning,
.bg-danger,
.bg-first {
	color: black !important;
}

.no-padding {
	padding: 0 !important;
}

.page-item.active a {
	background: #3b86ff;
	border: none !important;
}

.ninja-shadow {
	box-shadow: 0px 8px 15px 0px lightgrey;
}

.head-filter {
	margin: 20px 0;
	justify-content: space-between;
}

.lb-header-filter {
	color: #217fc3;
	font-weight: 600;
}

.__zoom_display {
	/* transform: scale(0.8);
  width: 132%;
  margin-left: -16%;
  margin-top: -130px !important; */
	zoom: 80%;
	margin-top: -150px !important;
}

.download-data {
	margin-bottom: 100px;
}
</style>
	
<style lang="css">
.tooltip {
	display: block !important;
	z-index: 10000;
}

.tooltip .tooltip-inner {
	background: rgb(18, 106, 207);
	color: white;
	border-radius: 5px;
	padding: 5px 10px 4px;
	box-shadow: 0px 0px 0px rgba(black, .1) !important;
}

.tooltip .tooltip-arrow {
	width: 0;
	height: 0;
	border-style: solid;
	position: absolute;
	margin: 5px;
	border-color: rgb(68, 110, 158);
	z-index: 1;
}

#dt-picker-detail-stock .mx-input {
	height: 30px !important;
}
</style>
  